import { Icon, IconProps } from "semantic-ui-react";

interface ArrowIconProps extends IconProps {
	isOpen: boolean;
}

export default function ArrowIcon({ isOpen, ...forward }: ArrowIconProps) {
	const direction = isOpen ? "down" : "right";

	return <Icon name={`angle ${direction}`} {...forward} />;
}
